import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';
import "./service.css";
// import serviceIllust01 from '../../assets/images/service-illust01.png';
import serviceIllust01 from '../../assets/images/service/animated-system.png';
import serviceIllust02 from '../../assets/images/service/animated-package1.png';
import serviceIllust03 from '../../assets/images/service/animated-support.png';
import serviceIllust04 from '../../assets/images/service/animated-infra.png';
import production from '../../assets/images/service/prod-management.jpeg';
import sales from '../../assets/images/service/sales-management.jpeg'
import logistics from '../../assets/images/service/logistics-management.jpg'
import factory from '../../assets/images/service/factory-automation.jpeg'
import motionBoard from '../../assets/images/service/motion-board.jpg'
import nkPrism from '../../assets/images/service/nk-prism.jpg'
import drSum from '../../assets/images/service/dr-sum.jpg'
import idea from '../../assets/images/service/idea.jpeg';
import workContent from '../../assets/images/service/work-content.jpeg';
import os from '../../assets/images/service/os.jpeg';
import programming from '../../assets/images/service/programming.jpeg';
import database from '../../assets/images/service/database.jpeg';
import network from '../../assets/images/service/network.jpeg';
import pcSetup from '../../assets/images/service/pc-setup.jpeg';
import memory from '../../assets/images/service/memory.jpeg';

class Service extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>サービス | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                <div id='service-container'>
                    <div className='container-box banner-container' id='service-banner-container'>
                        <div className='overlay'></div>
                        <div className='row'>
                            <div className='col'>
                                <h1>サービス</h1>
                                <h3>SERVICE</h3>
                            </div>
                        </div>
                    </div>
                    <div className='container-box' id='tagline-container'>
                        <div className='row'>
                            <div className='col'>
                                <h1>よりしなやかに、よりフレキシブルに。グローバルスタンダードの生産管理システムを創造</h1>
                                <p>
                                    お客様のニーズに合わせたシステムの実現に向けてクオリティの高い技術の提供を。
                                    弊社ではお客様のご要望を正確に把握し、システムのご提案から「開発・導入・運用保守」までを責任を持って対応します。
                                    また受託・派遣の両面での「技術提供」も積極的に行っております。
                                    製造業・流通業で実績を重ね、さらなる可能性に挑み続けるシステム開発のスペシャリスト集団、それが私たちです。
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* SYSTEM DEVELOPMENT */}
                    <div className='container-box service-type-box' id='system-container'>
                        <div className='row row-title'>
                            <div className='col col-hr'><hr></hr></div>
                            <div className='col-12 col-md-6 col-lg-4'>
                                <h1 className='text-blue'>システム開発</h1>
                                <h5>SYSTEM DEVELOPMENT</h5>
                            </div>
                            <div className='col col-hr'><hr></hr></div>
                        </div>
                        <div className='row row-content'>
                            <div className='col-12 col-lg-6 order-2 order-lg-1 col-content'>
                                <p>弊社では、システムのご提案から開発・導入・運用保守までを責任を持って行います。システムを実現するにあたっては、以下を念頭におきます。<br />
                                    <br />
                                    1. お客様のニーズを的確に把握すること<br />
                                    2. お客様の将来像を踏まえ、最適な実現方法であること<br />
                                    3. ハードウェア・パッケージ等のメーカーを限定せずに最適な構成であること<br />
                                    4. 開発コストに見合う投資効果をあげること
                                </p>
                            </div>
                            <div className='col order-1 order-lg-2 col-img'>
                                <img src={serviceIllust01} alt='service-illustration' />
                            </div>
                        </div>
                    </div>
                    <div className='container-box service-content-container' id='system-content-container'>
                        <div className='row'>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={production} className='card-img-top' alt='production' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text bg-orange'>生産管理システム</p>
                                        <p className='card-text'>
                                            生産業務に対応するシステム構築<br />
                                            &lt;主な項目&gt;<br />
                                            見積管理、受注管理、生産計画、購買外注管理、支払管理、生産指示、実績管理、在庫管理、出荷管理、販売・原価管理
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={sales} className='card-img-top' alt='sales' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text bg-orange'>販売管理システム</p>
                                        <p className='card-text'>
                                            販売業務に対応するシステム構築<br />
                                            &lt;主な項目&gt;<br />
                                            販売管理、受注管理、出荷管理、在庫管理、売上管理、発注管理、仕入管理、請求管理、支払管理、入金管理
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={logistics} className='card-img-top' alt='logistics' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text bg-orange'>物流管理システム</p>
                                        <p className='card-text'>
                                            物流業務に対応するシステム構築<br />
                                            &lt;主な項目&gt;<br />
                                            入庫管理、出庫管理、配車計画、在庫管理、棚卸管理
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={factory} className='card-img-top' alt='facrtory-automation' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text bg-orange'>FAシステム</p>
                                        <p className='card-text'>
                                            工場のさまざまな作業や工程におけるシステム構築<br />
                                            &lt;主な項目&gt;<br />
                                            作業工程の自動化、生産ライン管理、時間管理、稼動解析、IoT化、システムの集中制御
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END OF SYSTEM DEVELOPMENT */}

                    {/* PACKAGE DEVELOPMENT */}
                    <div className='container-box service-type-box' id='package-container'>
                        <div className='row row-title'>
                            <div className='col col-hr'><hr></hr></div>
                            <div className='col-12 col-md-8 col-lg-6 col-xl-5'>
                                <h1 className='text-blue'>パッケージ開発・導入</h1>
                                <h5>PACKAGE DEVELOPMENT</h5>
                            </div>
                            <div className='col col-hr'><hr></hr></div>
                        </div>
                        <div className='row row-content'>
                            <div className='col col-img'>
                                <img src={serviceIllust02} alt='package-management' />
                            </div>
                            <div className='col-12 col-lg-6 col-content'>
                                <p>弊社では、生産管理・販売管理パッケージやコミュニケーションツールなどのパッケージ開発に加えて、弊社お勧めの他社開発パッケージの導入とサポートを行っています。パッケージソフトを導入するメリットには、次のようなものがあります。<br />
                                    <br />
                                    1. 新規開発と比較し、導入期間を短縮でき、費用を抑えられる<br />
                                    2. 短期で導入することにより、競争上のメリットを得られる<br />
                                    3. 業務を標準化し、冗長性の排除ができる<br />
                                    4. パッケージのマニュアルを業務マニュアルとして流用できる
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='container-box service-content-container' id='package-content-container'>
                        <div className='row'>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img img-contain'>
                                        <img src={nkPrism} className='card-img-top' alt='nk-prism' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text'>弊社オリジナル製品 (NK-PRISM)</p>
                                        <p className='card-text'>
                                            販売と生産業務をきめ細かく網羅した統合業務管理システムです。
                                            充実した標準機能だけでなくシステム処理機能をカスタマイズすることで、
                                            お客様の強みを活かしたシステム構築が可能です:
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img img-contain'>
                                        <img src={drSum} className='card-img-top' alt='dr-sum' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text'>ウイングアーク1ｓｔ株式会社製 (Dr.Sum)</p>
                                        <p className='card-text'>
                                            高速データベース集計、多次元分析、レポート出力が可能なBIツールです。
                                            機能性・使用性が優れているため高度なデータの活用が可能になり、レポート
                                            作成にかかるコストを削減することができます。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img img-contain'>
                                        <img src={motionBoard} className='card-img-top' alt='motion-board' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text'>ウイングアーク1ｓｔ株式会社製 (MotionBoard)</p>
                                        <p className='card-text'>
                                            情報活用ダッシュボードとしてのBIツールです。リアルタイムな情報を直感的に、わかりやすく可視化します。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <img src={idea} className='card-img-top' alt='idea' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text'>市販ソフト・導入サポート</p>
                                        <p className='card-text'>
                                            上記以外のパッケージ製品の導入をご検討の場合も、弊社にお声掛けください。
                                            お勧めの製品や稼働実績などの情報を提供しながら、導入支援等をご提案させていただきます。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END OF PACKAGE DEVELOPMENT */}

                    {/* TECHNICAL SUPPORT */}
                    <div className='container-box service-type-box' id='tech-container'>
                        <div className='row row-title'>
                            <div className='col col-hr'><hr></hr></div>
                            <div className='col-12 col-md-6 col-lg-3'>
                                <h1 className='text-blue'>技術支援</h1>
                                <h5>TECHNICAL SUPPORT</h5>
                            </div>
                            <div className='col col-hr'><hr></hr></div>
                        </div>
                        <div className='row row-content'>
                            <div className='col-12 col-lg-6 order-2 order-lg-1 col-content'>
                                <p>弊社では、システム開発段階での技術者派遣だけではなく、システム化の検討段階から運用保守までの幅広い領域で、お客様のニーズにあった人材を提案します。<br />
                                    <br />
                                    システムの刷新を図りたいが、システム企画のノウハウがないというお客様にも、システム化を推進していける人材を提案します。
                                </p>
                            </div>
                            <div className='col order-1 order-lg-2 col-img'>
                                <img src={serviceIllust03} alt='techinical-support' />
                            </div>
                        </div>
                    </div>
                    <div className='container-box service-content-container' id='tech-content-container'>
                        <div className='row'>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={workContent} className='card-img-top' alt='work-content' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text'>作業内容</p>
                                        <p className='card-text'>
                                            調査分析・要件定義、基本設計、概要設計、詳細設計、製造、運用管理（ネットワーク・データベース)
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={os} className='card-img-top' alt='operating-system' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text'>対応OS</p>
                                        <p className='card-text'>
                                            Windows系、Linux系、iOS系、Android系
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={programming} className='card-img-top' alt='programming' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text'>対応言語</p>
                                        <p className='card-text'>
                                            C#、C、JAVA、COBOL、VB、VBA、ACCESS、ASP、VC、CASE/IDL、HOLON
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 col-xl-3'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={database} className='card-img-top' alt='database' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text'>データベース</p>
                                        <p className='card-text'>
                                            Oracle、SQLServer、Sybase、PostgreSQL、DB2
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END OF TECHNICAL SUPPORT */}

                    {/* INFRASTRUCTURE */}
                    <div className='container-box service-type-box' id='infra-container'>
                        <div className='row row-title'>
                            <div className='col col-hr'><hr></hr></div>
                            <div className='col-12 col-md-6 col-lg-4'>
                                <h1 className='text-blue'>インフラ構築</h1>
                                <h5>INFRASTRUCTURE CONSTRUCTION</h5>
                            </div>
                            <div className='col col-hr'><hr></hr></div>
                        </div>
                        <div className='row row-content'>
                            <div className='col col-img'>
                                <img src={serviceIllust04} alt='infrastructure' />
                            </div>
                            <div className='col-12 col-lg-6 col-content'>
                                <p>弊社では、お客様のさまざまな状況・ニーズに応じて、インフラ構築のサポートを行うことができます。<br />
                                    <br />
                                    ・情報漏えいに関して、我が社は大丈夫なのか不安…<br />
                                    ・アプリケーションの起動が遅くなる等、動作速度に不満がある<br />
                                    ・ITインフラ整備に無駄な時間やコストをかけたくない<br /><br />
                                    そんなお悩みをお手軽に・低価格で解消します。まずはお気軽にご相談ください。
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='container-box service-content-container' id='infra-content-container'>
                        <div className='row'>
                            <div className='col-12 col-md-6 col-xl-4'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={network} className='card-img-top' alt='network' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text bg-orange'>クライアントサーバ構築</p>
                                        <p className='card-text'>
                                            シンクライアントを中心としたグリーンITシステムをご提案。
                                            今ある資産を有効活用し、低コストでシンクライアント環境を実現します。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={pcSetup} className='card-img-top' alt='pc-setup' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text bg-orange'>パソコンのセットアップ</p>
                                        <p className='card-text'>
                                            お客様の代わりに手間のかかるパソコンの設置・設定、 インターネットへの接続、プリンターの接続等の作業を行います。
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-xl-4'>
                                <div className='card'>
                                    <div className='card-img'>
                                        <div className='overlay'></div>
                                        <img src={memory} className='card-img-top' alt='computer-memory' />
                                    </div>
                                    <div className='card-body'>
                                        <p className='card-title-text bg-orange'>パソコンのメモリ増設</p>
                                        <p className='card-text'>
                                            パソコンがメモリ不足に陥っている場合、パソコンが快適に動作するようメモリの増設、交換をサポートします。
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END OF INFRASTRUCTURE */}
                </div>
            </React.Fragment>
        )
    }
}

export default Service;